    window.onload = function () {
        let elements = document.getElementsByClassName("expand");
        let toggle = 0;
        for (let i = 0; i < elements.length; i++) {
            elements[i].onclick = function () {
                if (toggle == 0) {
                    document.getElementById("product-grid").style.height = "auto";
                    document.getElementById("product-grid").style.mask = "none";
                    document.getElementById("show").innerHTML = "Show Less";
                    toggle = 1;
                } else {
                    document.getElementById("product-grid").style.height = "revert-layer";
                    document.getElementById("product-grid").style.mask = "var(--mask)";
                    document.getElementById("show").innerHTML = "Show More";
                    toggle = 0;
                }
                

            }
        }
    };